import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password.page.html',
  styleUrl: './forgot-password.page.scss',
  imports: [
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    RouterLink,
  ],
})
export class ForgotPasswordPage {
  private readonly authService = inject(AuthService);
  private readonly formBuilder = inject(FormBuilder);

  public readonly form = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
  });

  public readonly isLoading = signal(false);
  public readonly isSubmitted = signal(false);

  public onSubmit(): void {
    if (!this.form.valid || this.isLoading()) {
      return;
    }

    this.isLoading.set(true);

    const email = this.form.value.email as string;

    this.authService.forgotPassword(email).subscribe({
      next: () => {
        this.isLoading.set(false);
        this.isSubmitted.set(true);
      },
      error: () => {
        // Always show success to prevent email enumeration
        this.isLoading.set(false);
        this.isSubmitted.set(true);
      },
    });
  }
}
